module.exports = __webpack_public_path__ + "static/media/satisfied.1546d0cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/emoji/satisfied.png
// module id = 58
// module chunks = 0